/* eslint-disable */
import { Application } from '@hotwired/stimulus';
import { registerControllers } from 'stimulus-vite-helpers';

const application = Application.start();
/* eslint-disable-next-line no-unused-vars */
const controllers = import.meta.glob('../controllers/**/*_controller.js', { eager: true });
registerControllers(application, controllers);
